import { IconProps, NocIconGenerator } from '../common';

export const ArrowLeft2 = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ArrowLeft2',
            path: (
                <path
                    stroke="#292D32"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                    strokeWidth={2}
                    d="M16 19.92 9.48 13.4c-.77-.77-.77-2.03 0-2.8L16 4.08"
                />
            ),
        }}
    />
);
